// JS to execute after DOMContentLoaded
require('./assets/js/_entry.js');

